module.exports = __webpack_public_path__ + "images/mclaren52e2af30f9d790a59a2f3c85693f9953.png";